import { render, staticRenderFns } from "./CMSTutorial.vue?vue&type=template&id=3ce2c374&scoped=true&"
import script from "./CMSTutorial.vue?vue&type=script&lang=js&"
export * from "./CMSTutorial.vue?vue&type=script&lang=js&"
import style0 from "./CMSTutorial.vue?vue&type=style&index=0&id=3ce2c374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce2c374",
  null
  
)

export default component.exports